import config from '../config/config.json';

export let DEBUG_MODE = true;

const urlSuspend = 'suspend.json';
const urlActualVersionAvailable = 'version.json';
const urlStaticSurvey = 'data/survey.json';
const urlStaticDemoSurvey = 'data/demo/surveyDemo.json';
const urlStaticCriticalPoint = 'data/criticalExample.json';
const urlStaticSupervisors = 'data/supervisors.json';
const urlCoreApiSurvey = 'testGiving/examByPin/byPin';
const urlCoreApiSurveyById = 'testGiving/examById/byId';
const urlCoreApiSurveyByPinIdExternal =
  'testGiving/examByPinExternal/byPinExamId';
const urlCoreApiSurveyByToken = 'testGiving/examByToken/byToken';
const urlStaticCheckAccess = 'data/checkAccess.json';

const urlStaticApiTextsPackage = 'data/';
const urlStaticApiTests = 'data/';
const urlStaticApiCSS = 'data/';
const urlStaticApiMedia = 'data/';

const urlCoreApiAlarm = 'exam/alarm/';
const urlCoreApiResults = 'result/get/byExamTest';
const urlCoreApiSaveResults = 'result/saveResults/';
const urlCoreApiSaveResult = 'result/saveResult/';

const urlCoreStethoClientToken = 'stetho/get/clientToken';
const urlCoreStethoClientMediaToken = 'stetho/get/clientMediaToken';

const urlECGUploadRecord = 'ecg';
const urlECGExtInfo = 'ecg/get/extinfo';
const urlECGReport = 'ecg/get/report';
const urlIndicatorCalculateResults = 'indicatorTest/calculateResults';

const urlServer = config.URL_SERVER;
const urlECGProxy = config.URL_ECG_PROXY || config.URL_SERVER;

export const urlPeer2PeerServer = config.CHAT_SERVER;
export const defaultMonitorRoomId = config.MONITOR_ROOM;
export const useMonitor = urlPeer2PeerServer ? true : false;
export const finishPageUrl = config.FINISH_PAGE_URL;

export const ulrDefaultDbTexts = 'common/db_texts/spd-db_texts.json';

export const brandSPD = config.BRAND;
export const cooperatorSPD = config.COOPERATOR;

let brightScreenMode = true;

export function switchOffDebugMode() {
  DEBUG_MODE = false;
}

export function switchScreenMode() {
  brightScreenMode = !brightScreenMode;
}

export function getScreenMode() {
  return brightScreenMode;
}

let runAsDemo = false;
export function setRunAsDemo(demo: boolean) {
  runAsDemo = demo;
}

export function isDemoMode() {
  return runAsDemo;
}

let runLocalTestStatus = true;
export function setRunTestWithCore(core: boolean) {
  runLocalTestStatus = !core;
}

export function runLocalTest() {
  return runLocalTestStatus;
}

let modeAuthorizedStatus = false;
export function setModeAuthorized(authorize: boolean) {
  modeAuthorizedStatus = authorize;
}
export function modeAuthorized() {
  return modeAuthorizedStatus;
}

function getUrlStaticSurvey(): string {
  return runAsDemo ? urlStaticDemoSurvey : urlStaticSurvey;
}

export function getUrlSurvey(): string {
  return runLocalTestStatus
    ? getUrlStaticSurvey()
    : urlServer + urlCoreApiSurvey;
}

export function getUrlSurveyByPinIdExternal(): string {
  return runLocalTestStatus
    ? getUrlStaticSurvey()
    : urlServer + urlCoreApiSurveyByPinIdExternal;
}

export function getUrlSurveyByToken(): string {
  return runLocalTestStatus
    ? getUrlStaticSurvey()
    : urlServer + urlCoreApiSurveyByToken;
}

export function getUrlSurveyById(): string {
  return runLocalTestStatus
    ? getUrlStaticSurvey()
    : urlServer + urlCoreApiSurveyById;
}

export function getUrlTextsPackage(): string {
  return urlStaticApiTextsPackage;
}
export function getUlrTests(): string {
  return urlStaticApiTests;
}

export function getUrlCSS(): string {
  return urlStaticApiCSS;
}

export function getUrlMedia(): string {
  return urlStaticApiMedia;
}

export function getUrlAlarm(): string {
  return urlServer + urlCoreApiAlarm;
}

export function getStethoClientToken(): string {
  return urlServer + urlCoreStethoClientToken;
}

export function getStethoClientMediaToken(): string {
  return urlServer + urlCoreStethoClientMediaToken;
}

export function getUrlIndicatorCalculateResults(): string {
  return urlServer + urlIndicatorCalculateResults;
}

export function getUrlECGUploadRecord(): string {
  return urlECGProxy + urlECGUploadRecord;
}

export function getUrlECGExtInfo(): string {
  return urlECGProxy + urlECGExtInfo;
}

export function getUrlECGReport(): string {
  return urlECGProxy + urlECGReport;
}

export function getUrlChatForExam(surveyId: string, token: string) {
  const param = `/chat?exam=${surveyId}&token=${token}`;
  return urlPeer2PeerServer + param;
}

export function getUrlTurnCredentials(token: string): string {
  return (
    urlPeer2PeerServer +
    `/api/turn-credentials?token=${encodeURIComponent(token)}`
  );
}

export function getFinishPageUrl(): string {
  return finishPageUrl;
}

export function getUrlChangeSex(surveyId: string) {
  const urlCoreApiSurveyChangeDates = `exam/exam/${surveyId}/changeSex`;
  return urlServer + urlCoreApiSurveyChangeDates;
}

export function getUrlTestChangeDates(
  surveyId: string,
  testId: string,
): string {
  const urlCoreApiTestChangeDates = `examTest/exam/${surveyId}/test/${testId}/changeDates`;

  return urlServer + urlCoreApiTestChangeDates;
}

export function getUrlSurveyCriticalPoint(surveyId: string): string {
  const urlCoreApiSurveyCriticalPoint = `exam/criticalPoint/${surveyId}`;
  return runLocalTestStatus
    ? urlStaticCriticalPoint
    : urlServer + urlCoreApiSurveyCriticalPoint;
}

export function getUrlSurveySupervisors(surveyId: string): string {
  const urlCoreApiSurveySupervisors = `exam/supervisors/${surveyId}`;
  return runLocalTestStatus
    ? urlStaticSupervisors
    : urlServer + urlCoreApiSurveySupervisors;
}

export function getUrlActualVersionAvailable(): string {
  return urlActualVersionAvailable;
}

export function getUrlSuspend(): string {
  return urlSuspend;
}

export function getUrlCheckAccess(device: string): string {
  const urlCoreApiCheckAccess = `access/checkAccess/byDevice?device=${device}`;
  return runLocalTestStatus
    ? urlStaticCheckAccess
    : urlServer + urlCoreApiCheckAccess;
}

export function getUrlSurveyChangeDates(surveyId: string): string {
  const urlCoreApiSurveyChangeDates = `exam/exam/${surveyId}/changeDates`;

  return urlServer + urlCoreApiSurveyChangeDates;
}

export function getUrlResults(): string {
  return urlServer + urlCoreApiResults;
}

export function getUrlSaveResults(): string {
  return urlServer + urlCoreApiSaveResults;
}

export function getUrlSaveResult(): string {
  return urlServer + urlCoreApiSaveResult;
}

export function getBuildVersion(): string {
  return process.env.BUILD_VERSION as string;
}

export function getBuildVersionToShow(): string {
  return getBuildVersion().replace(/[-.:]/g, '');
}
